import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from "src/com/sixdee/crbtportal/ui/toolkit/uicomponentcss";

export interface DedicateFlashCardMessageCSSStyle extends UIComponentCSSStyle
{
   
   
}

export class DedicateFlashCardMessageCSSStyleImpl extends UIComponentCSSStyleImpl implements DedicateFlashCardMessageCSSStyle
{

}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/dedicateflashmessage/dedicatecard/dedicateflashcardmessagecss.tsx